import React, { useRef } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { Avatar, Button, Typography, Divider } from '@mui/material'
import { Box } from '@mui/system'

import { convertToPersianNumber, convertHourToPersianDigit } from 'utils';
import { ArrowLeftIcon, ClockIcon } from 'Sui_Icons';
import { Link } from 'react-router-dom';


let URL;
if (process.env.NODE_ENV === "production") {
    URL = `${process.env.REACT_APP_PRODUCTION_API_URL}`;
} else {
    URL = `${process.env.REACT_APP_DEVELOPMENT_API_URL}`;
}


export const CourseCard = ({ img, title, caption, teacherName , teacherPhoto, length, price , id}) => {

    const navigate = useNavigate();
    const location = useLocation();
    const descriptionRef = useRef();
    
    // Check if current path is the interactive learning list page
    const isInteractiveLearningList = location.pathname === '/dashboard/intractivelearning/list';
    
    // Check if current path contains a course detail page (any course detail URL)
    const isOnCourseDetailPage = location.pathname.includes('/coursedetail/');
    
    // Determine navigation path based on current location
    const getNavigationPath = () => {
        if (isInteractiveLearningList || isOnCourseDetailPage) {
            return `/coursedetail/${id}`; // Absolute path for interactive learning list and course detail pages
        }
        return `coursedetail/${id}`; // Relative path for other pages
    };

    function truncateHTML(html, maxWords) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const allNodes = doc.body.childNodes;
    
        let wordCount = 0;
        let isTruncated = false;
    
        const walkNodes = (node) => {
            if (isTruncated) return;  // Stop recursion once truncated
            if (node.nodeType === Node.TEXT_NODE) {
                let words = node.textContent.split(/\s+/).filter(word => word.length);
                if (wordCount + words.length > maxWords) {
                    words = words.slice(0, maxWords - wordCount);
                    node.textContent = words.join(' ') + '...';
                    isTruncated = true;
                }
                wordCount += words.length;
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                Array.from(node.childNodes).forEach(walkNodes);
                if (isTruncated) {
                    while (node.nextSibling) {
                        node.parentNode.removeChild(node.nextSibling);
                    }
                }
            }
        };
    
        Array.from(allNodes).forEach(walkNodes);
    
        return doc.body.innerHTML;
    }

    const truncatedCaption = truncateHTML(caption, 15);

    return (
        <Box sx={{ px: { xs: 4, lg: 2 }, py: 2, display: 'flex', flexDirection: 'column', background: 'white', borderRadius: 2, position: 'relative', bottom: 0, transition: 'all ease 0.4s', color: 'CaptionText', cursor: 'pointer'}} component={'a'} onClick={()=>navigate(getNavigationPath())} >
            {/* href={`coursedetail/${id} */}
            <Box sx={{ borderRadius: 1.1, mb: 2, position: 'relative', overflow: 'hidden',display:'flex',justifyContent:'center' }}>
                <Box sx={{ height: { xs: '180px', lg: '170px' }, width: { xs:'100%' ,  lg: '230px' }}}><img style={{ width: '100%', height: '100%',borderRadius:'9px' }} src={`${URL}/api/v1/${img}`} /></Box>
                <Box sx={{ position: 'absolute', bottom: '5%', left: '5%', py: 0.5, px: 1, background: 'white', borderRadius: 1, display: 'flex', alignItems: 'center', verticalAlign: 'middle' }}>
                    <ClockIcon sx={{ mr: 0.5 }} />
                    <Typography sx={{ mt: 0.5 }} color='primary.main' fontSize={14}>{convertHourToPersianDigit(length)}</Typography>
                </Box>
            </Box>

            <Typography gutterBottom fontSize={14} fontWeight={'bold'} >{title}</Typography>
            <Typography ref={descriptionRef} gutterBottom color='grey.600' fontSize={13} dangerouslySetInnerHTML={{ __html: truncatedCaption }} />
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', mt: 2, alignItems: 'center' }}>
                <Typography fontSize={14} fontWeight={'medium'}>مدرس دوره</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Avatar sx={{ height: '30px', width: '30px' }} src={teacherPhoto} alt={teacherName} />
                    &nbsp;&nbsp;
                    <Typography fontSize={14} fontWeight={'medium'}>{teacherName}</Typography>
                </Box>
            </Box>

            <Divider />
            {!isInteractiveLearningList && (
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: !price ? 'space-between' : 'space-around', background: 'rgba(238, 238, 238, 0.33)', borderRadius: 1, mb: 1, py: 1.5, px: !price ? 4 : 1 }}>
                    <Typography fontSize={14} color='grey.600'>قیمت دوره</Typography>
                    <Typography color={length ? 'CaptionText' : 'primary.main'} fontSize={16} fontWeight={'bold'} >{price ? convertToPersianNumber(price) + ' تومان' : 'رایگان'}</Typography>
                </Box>
            )}
            <Button onClick={()=>navigate(getNavigationPath())} endIcon={<ArrowLeftIcon size={'25px'} />}><Typography color='primary.main' fontWeight={'bold'}>مشاهده دوره</Typography></Button>
        </Box>
    )

}
